import { useFetch, usePost } from '@selfserve/react-hooks';
import { MarketingInfoAnswer, PackageDetail } from './interfaces';
import { apiEndpoints } from '@selfserve/react-utils';
import { LoginUrlResponse } from '@selfserve/react-feature-purchase-plan';

export const usePackageDetailRequest = (hash: string) => {
  const url = apiEndpoints.packageDetail.replace(':hash', hash);
  return useFetch<PackageDetail>(url);
};

export const useSetMarketingInfoRequest = (id: string) => {
  const url = apiEndpoints.setMarketingInfo.replace(':id', id);
  return usePost<MarketingInfoAnswer, LoginUrlResponse>(url);
};

export const useEmailValidation = (hash: string) =>
  useFetch<{
    subscriptionId: string;
    status?: string;
    access_token?: string;
    nextStepUrl?: string;
    nextState?: string;
    requiresAuth?: boolean;
  }>(
    apiEndpoints.emailValidationById.replace(':id', hash)
  );

export * from './interfaces';
export * from './schemas';
